// src/customAxios.ts
import { customAxios as apiClientCustomAxios } from "@getbread/api-client-axios";
var versionHeader = ["true"].includes("true") ? { "X-API-VERSION": "v2" } : {};
var customAxios = (config, options) => {
  return apiClientCustomAxios(config, {
    ...options,
    headers: { ...versionHeader, ...options?.headers }
  });
};

export {
  customAxios
};
//# sourceMappingURL=chunk-RSSSV4W5.mjs.map